export class RegroupementPlatFilterMl {
  ids : number[] = [];
}
